import { useGlobalPermissions } from '@lopo-tech/lopo-api'

import { AuthorizationReason, hasAuthorizationReason } from 'src/utils/authorization_reasons'

export function useIsEventCreationEnabled (): boolean {
  const { data: permissionData } = useGlobalPermissions()

  return !hasAuthorizationReason(
    permissionData?.globalPermissions?.canCreateEvent?.reasons?.details,
    AuthorizationReason.POSTING_NOT_PERMITTED
  )
}
